<template>
  <div>
    <homeBanner :imgarry="data" v-if="data.length"></homeBanner>
    <div class="fix-banner" v-else></div>
    <searchC></searchC>
    <!--主内容开始-->
    <!--威遥合作客户-->

    <!--威遥合作客户-->
    <div class="pro">
      <!--威遥产品中心-->
      <div style="height:30px;"></div>
      <div class="pro_l">
        <h2>
          <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">威遥产品中心</router-link>
        </h2>
        <h3>
          <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">按产品类别分</router-link>
        </h3>
        <ul class="clearfix">
          <li v-for="item in lista" :key="item.id">
            <router-link tag="a" :to="{ name: 'product', params: { id: item.id}}">{{item.mc}}</router-link>
          </li>
        </ul>
        <h3>
          <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">按应用行业分</router-link>
        </h3>
        <ul class="clearfix">
          <li v-for="item in listb" :key="item.id">
            <a href="#">{{item.mc}}</a>
          </li>
        </ul>
        <h3>
          <a title="焊接材料" href="#">焊接材料</a>
        </h3>
        <ul class="clearfix">
          <li v-for="item in listc" :key="item.id">
            <router-link tag="a" :to="{ name: 'product', params: { id: item.id}}">{{item.mc}}</router-link>
          </li>
        </ul>
        <h3>
          <a title="焊接配件" href="#">焊接配件</a>
        </h3>
        <ul class="clearfix">
          <li v-for="item in listd" :key="item.id">
            <router-link tag="a" :to="{ name: 'product', params: { id: item.id}}">{{item.mc}}</router-link>
          </li>
        </ul>
        <h4>
          全国服务热线:
          <b>021-65056515</b>
        </h4>
      </div>

      <!--威遥产品中心-->
      <div class="pro_r">
        <!--焊机热销产品-->

        <h3>
          <span>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <img src="../../static/images/p_mor.gif" alt="more" title="more" />
            </router-link>
          </span>
          <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">焊机热销产品</router-link>
        </h3>

        <div class="k_list">
          <div class="k_item" v-for="item in hotlist" :key="item.id">
            <router-link tag="a" target="_blank"  :to="{ name: 'pinfo', params: { id: item.id,nid:5 }}">
            <img :src="item.img" />
            <div>{{item.name}}</div>
            </router-link>
          </div>
        </div>

        <!--产品切换-->
      </div>
    </div>

    <div
      :style="{height:'340px', background:'url('+require('../../static/images/14.jpg')+')  no-repeat center'}"
    ></div>
    <div style="height:60px; clear:both;"></div>

    <!--优势-->
    <div class="ys_bg1">
      <div class="ys">
        <dl class="ys02">
          <dt>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <i>
                <b>
                  采用
                  <span>进口元器件</span>组装性价比高
                </b>完美替代进口管焊设备
              </i>
            </router-link>
          </dt>
          <dd>
            我们的团队来自不同品牌管焊设备厂家的专业人员，分析各个品牌的优势，学其所长。核心元器件采用
            <span>进口部件</span>，核心技术自主研发，制造出符合中国国情
            <span>高性价比</span>的管焊设备，适合工厂生产使用和外出施工等恶劣环境。返修率低于1%，使用寿命长。
          </dd>
        </dl>
        <dl class="ys03">
          <dt>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <i>
                <b>
                  售后服务
                  <span>零担忧</span>
                </b>维修免费提供备用机
              </i>
            </router-link>
          </dt>
          <dd>
            考虑国内客户的恶劣生产工作环境，免除客户购买后顾虑，我司现推出
            <span>两年免费质保期</span>，质保期内同一故障出现2次以上，可协商免费退换货处理。设备维修期间，可
            <span>免费</span>提供备用设备。
          </dd>
        </dl>
        <dl class="ys07">
          <dt>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <i>
                <b>
                  <span>一站式</span>服务平台
                </b>提供管道焊接、切割完整解决方案
              </i>
            </router-link>
          </dt>
          <dd>
            提供切管机、平口机、钨极磨削机和封闭自动轨道焊机，全部产品均由我们
            <span>自主研发</span>，国内生产组装，相比于进口设备的价格，最大化的降低采购成本。
            <i>
              <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
                <img
                  src="../../static/images/ys_ck.gif"
                  width="102"
                  height="21"
                  alt="查看详情"
                  title="查看详情"
                />
              </router-link>
              <a
                href="http://wpa.qq.com/msgrd?v=3&site=威遥焊接&menu=yes&uin=497254175"
                target="_blank"
                title="立即咨询"
              >
                <img src="../../static/images/ys_zx.gif" alt="立即咨询" title="立即咨询" />
              </a>
            </i>
          </dd>
        </dl>
      </div>
    </div>
    <div class="ys_bg2">
      <div class="ys">
        <dl>
          <dt>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <i>
                <b>
                  维修
                  <span>成本低廉</span>
                </b>服务通畅及时
              </i>
            </router-link>
          </dt>
          <dd>
            您是否采购过价格高昂的
            <span>进口焊接设备</span>，一旦设备出保修期后维修费用昂贵让您十分懊恼，可又无可奈何。选择我们真正的工厂式的
            <span>维修解决方案</span>，我们不通过维修赚钱，我们通过服务来赚取口碑。打破行业维修潜规则，突波您的心理价位。
          </dd>
        </dl>

        <dl class="ys08">
          <dt>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <i>
                <b>
                  <span>15年</span>焊接技术经验
                </b>专家
                <span>一对一指导</span>安装调试
              </i>
            </router-link>
          </dt>
          <dd>
            封闭自动轨道焊机采用进口西门子PLC控制，中文人机界面，保证操作者
            <span>10分钟学会，30分钟掌握</span>，傻瓜式自动生成专家焊接参数，人人都是焊接技师。同样具备所有参数开放手动调节功能，适合专业焊接技师经验调节参数。
          </dd>
        </dl>
        <dl class="ys04">
          <dt>
            <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
              <i>
                <b>
                  租赁设备结算方式
                  <span>灵活</span>
                </b>
                <Br />
              </i>
            </router-link>
          </dt>
          <dd>
            管焊设备提供免费试用，短期或中
            <span>长期租赁，免押金</span>，结算方式灵活，最小天为单位，就算您只租用一天我们也让使用满意，价格比市场上其他设备价格低30%-100%，先租后买模式，免付租金。详情欢迎来电咨询18616336851.
            <i>
              <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
                <img
                  src="../../static/images/ys_ck.gif"
                  width="102"
                  height="21"
                  alt="查看详情"
                  title="查看详情"
                />
              </router-link>
              <a
                href="http://wpa.qq.com/msgrd?v=3&site=威遥焊接&menu=yes&uin=497254175"
                target="_blank"
                title="立即咨询"
              >
                <img src="../../static/images/ys_zx.gif" alt="立即咨询" title="立即咨询" />
              </a>
            </i>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import homeBanner from "@/views/banner";
import searchC from "@/views/search";
import { home } from "@/utils/api"; //引入api至当前文件
export default {
  data() {
    return {
      data: [],
      lista: [],
      listb: [],
      listc: [],
      listd: [],
      hotlist: []
    };
  },
  components: {
    homeBanner,
    searchC
  },
  mounted() {
    home().then(res => {
      this.data = res.banners.map(item => {
        return item.src;
      });
      this.lista = res.catlist.filter(item => {
        return item.dlid == 1;
      });
      this.listb = res.catlist.filter(item => {
        return item.dlid == 3;
      });
      this.listc = res.catlist.filter(item => {
        return item.dlid == 4;
      });
      this.listd = res.catlist.filter(item => {
        return item.dlid == 5;
      });
      this.hotlist = res.hotlist;
    });
  },
  methods: {
    toInfo() {
      this.$router.push({
        name: "kernelpage",
        params: {
          id: 10
        }
      });
    }
  }
};
</script>

<style scoped>
.k_list {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}
.k_item {
  width: 305px;
  height: 300px;
  margin-right: 13px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  border: 1px solid #e5e5e5;
}
.k_item img {
  width:260px;
  height: 260px;
  margin-bottom: 6px;
  margin-top: 10px;
}
</style>
